<script>
import { VTooltip, VPopover } from 'v-tooltip';

/**
 * Small pop-up box that appears when the user moves the mouse pointer over an
 * element. Essentially a wrapper around v-tooltip with some predefined
 * properties and styles
 * https://github.com/Akryum/v-tooltip
 *
 */

// Global options
VTooltip.options.defaultClass = 'ntv-tooltip';
VTooltip.options.defaultBoundariesElement = document.body;
VTooltip.options.defaultPopperOptions = {
  preventOverflow: {
    enabled: false
  },
  flip: {
    enabled: false
  }
};

export default { VTooltip, VPopover };
</script>

<style lang="scss">
.tooltip,
.ntv-tooltip {
  display: block !important;
  z-index: 9999;
  margin-top: -1px;
  max-width: 350px;
  line-height: 1.5em;

  .wrapper {
    padding-bottom: 0;
  }

  .tooltip-inner {
    background: white;
    border-radius: 3px;
    padding: 10px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  }

  .tooltip-arrow {
    width: 10px;
    height: 10px;
    position: absolute;
    overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      width: 10px;
      height: 10px;
      background: white;
      transform: translateX(-50%) translateY(-50%) rotate(45deg);
      top: 0;
      left: 50%;
    }
  }

  &[x-placement^='top'] {
    margin-bottom: 10px;

    .tooltip-arrow {
      bottom: -8px;
      left: calc(50% - 8px);
      margin-top: 0;
      margin-bottom: 0;

      &::after {
        box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.5);
      }
    }
  }

  &[x-placement^='bottom'] {
    margin-top: 10px;

    .tooltip-arrow {
      transform: rotate(180deg);
      top: -8px;
      left: calc(50% - 8px);
      margin-top: 0;
      margin-bottom: 0;

      &::after {
        box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.25);
      }
    }
  }

  &[x-placement^='right'] {
    margin-left: 10px;

    .tooltip-arrow {
      transform: rotate(90deg);
      left: -8px;
      top: calc(50% - 8px);
      margin-left: 0;
      margin-right: 0;

      &::after {
        box-shadow: 1px 0px 1px 0px rgba(0, 0, 0, 0.25);
      }
    }
  }

  &[x-placement^='left'] {
    // For some reason left side has a ghost margin of 1px so decrease this one
    // to adjust for it.
    margin-right: 9px;

    .tooltip-arrow {
      transform: rotate(-90deg);
      right: -8px;
      top: calc(50% - 8px);
      margin-left: 0;
      margin-right: 0;

      &::after {
        box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.25);
      }
    }
  }

  // &.popover {
  //   $color: #f9f9f9;

  //   .popover-inner {
  //     background: $color;
  //     color: black;
  //     padding: 24px;
  //     border-radius: 5px;
  //     box-shadow: 0 5px 30px rgba(black, 0.1);
  //   }

  //   .popover-arrow {
  //     border-color: $color;
  //   }
  // }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
}
</style>
